"use strict";
/* globals module */
/**
 * @module userSkillClient
 * @description  User Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var UserSkillClient = /** @class */ (function () {
    function UserSkillClient(userSkillRoute, apiClient) {
        this.userSkillRoute = userSkillRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserSkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.userSkillRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userSkillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserSkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user skill resource.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userSkillClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userSkillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user skill action has been performed; this action creates a new user skill resource.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user skill action has been performed.
     * @example userSkillClient.create({ skillName : '<skill-name>', userId: '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user skill action has been performed; this action updates a user skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user skill object used to update specified user skill resource.
     * @returns A promise that is resolved once the update user skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skill.description = '<description>';
                       userSkillClient.update(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserSkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    userSkillClient.remove(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserSkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserSkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserSkillRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserSkillRoute !== "undefined" && _1.UserSkillRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserSkillClient);
    return UserSkillClient;
}());
exports.UserSkillClient = UserSkillClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
